import { render, staticRenderFns } from "./work-order-view.vue?vue&type=template&id=2f122967&scoped=true"
import script from "./work-order-view.vue?vue&type=script&lang=js"
export * from "./work-order-view.vue?vue&type=script&lang=js"
import style0 from "./work-order-view.vue?vue&type=style&index=0&id=2f122967&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f122967",
  null
  
)

export default component.exports